import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE MENORESET SYSTEM™',
  ideal: 'Any woman wishing to regain physical control, erase painful symptoms naturally, and balance her hormones from scratch',
  was: '$54',
  now: '$27',
  features: ['6 Complete Tomes (60+ pages)', 'Metabolic Cooling and Sleep protocols', 'Real fat-burning & mental clarity frameworks', '30-Day routine with visible hormonal health', '3 Free Premium Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The MenoReset System™'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-129" data-mp="3w08cy4tljg8s">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-130" data-mp="4scp558ik0u5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(168,90,90,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-131" data-mp="9ta1v2ar82o9">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-132" data-mp="3n5ak0xqg83hg">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-133" data-mp="3rzya3113p5y5">
            <span className="font-semibold text-plum/80" data-id="element-134" data-mp="2uj96p2wi5vmn">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-135" data-mp="2zgivcgc2i39f">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-136" data-mp="2zfpz49aqiw5j">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "80px",
            paddingBottom: "26px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "20px",
            fontWeight: "800"
          }} data-id="element-137" data-mp="2mi1lzkiho3d1">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-138" data-mp="2w7bf93p2js2q">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-139" data-mp="28iinzkje68eg">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-140" data-mp="2iggc88194572">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-141" data-mp="2dgk888sk0dri">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-142" data-mp="3tv3cfxo4mtab" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-143" data-mp="3ovh2bx3lht5q">
            <CTAButton size="md" data-id="element-144" data-mp="9udy4r1spjr">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-145" data-mp="cqc9u6t5g8q">
            You save $120 USD (82% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-146" data-mp="3nfv367ll45ob">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="j151cbxkek6w">
                <Icon className="h-4 w-4 text-grape" data-id="element-148" data-mp="j37p0pb8w18g" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-149" data-mp="a9356puj3q2f" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-150" data-mp="a7s10ox68gas">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-151" data-mp="11zr3lu4tihce" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-152" data-mp="11yg0lwj75dmc">
            <span className="font-display font-bold text-plum" data-id="element-153" data-mp="16rhga6r89h6z">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not match your expectations or does
            not give you the relief you were looking for, simply request your refund and we return
            100% of your money. We want you to balance your body with complete peace of mind,
            risk-free.
          </p>
        </div>
      </div>
    </section>;
}